export const marks = Object.freeze({
  worklist: {
    load: {
      start: 'worklist.load.start',
      request_fired: 'worklist.load.request_fired',
      data_ready: 'worklist.load.data_ready',
      paint: 'worklist.load.paint',
    },
    pagination: {
      start: 'worklist.pagination.start',
      request_fired: 'worklist.pagination.request_fired',
      data_ready: 'worklist.pagination.data_ready',
      paint: 'worklist.pagination.paint',
    },
    patient_jacket: {
      start: 'worklist.patient_jacket.start',
      worklist_item_fetch: 'worklist.patient_jacket.worklist_item_fetch',
      paint: 'worklist.patient_jacket.paint',
      select_prior: 'worklist.patient_jacket.select_prior',
      selected_prior_load: 'worklist.patient_jacket.selected_prior_load',
      selected_prior_paint: 'worklist.patient_jacket.selected_prior_paint',
      priors_summary_start: 'worklist.patient_jacket.priors_summary_start',
      priors_summary_load: 'worklist.patient_jacket.priors_summary_load',
      priors_summary_paint: 'worklist.patient_jacket.priors_summary_paint',
    },
    crud: {
      open_dialog: 'worklist.crud.open_dialog',
      open_delete_dialog: 'worklist.crud.open_delete_dialog',
      abandon: 'worklist.crud.abandon',
      submit: 'worklist.crud.submit',
      save: 'worklist.crud.save',
      delete: 'worklist.crud.delete',
    },
    columns: {
      resize_start: 'worklist.columns.resize_start',
      resize_end: 'worklist.columns.resize_end',
      resize_save_start: 'worklist.columns.resize_save_start',
      resize_save_end: 'worklist.columns.resize_save_end',
      adjust_start: 'worklist.columns.adjust_start',
      adjust_save: 'worklist.columns.adjust_save',
      adjust_paint: 'worklist.columns.adjust_paint',
      pin_start: 'worklist.columns.pin_start',
      pin_save: 'worklist.columns.pin_save',
      pin_paint: 'worklist.columns.pin_paint',
      reorder_start: 'worklist.columns.reorder_start',
      reorder_save: 'worklist.columns.reorder_save',
      reorder_paint: 'worklist.columns.reorder_paint',
    },
    drawer: {
      open_start: 'worklist.drawer.open_start',
      open_paint: 'worklist.drawer.open_paint',
    },
  },
} as const);
